export default __webpack_public_path__ + "static/media/icone_novidades.be2e46ae.svg";